import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth/AuthContext'
import { Layout } from './components/Layout'
import { Spinner } from './components/Ui'
import { AccountsPage, ProfilePage } from './features/Accounts'
import { DashboardPage } from './features/Dashboard'
import { DoorCodeDetailPage, DoorCodesPage } from './features/DoorCodes'
import { DoorDetailPage, DoorsPage } from './features/Doors'
import { GroupDetailPage, GroupsPage } from './features/Groups'
import { LoginPage, PasswordChangePage } from './features/Login'
import { AuditPage, LogPage } from './features/Logs'
import {
  OrganizationSettingsPage, OrganizationsPage,
} from './features/Organizations'

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </AuthProvider>
  )
}

function Router() {
  const { me, loading } = useAuth()

  if (loading) return <Spinner />

  // Nicht angemeldet: nur die Anmeldung ist erreichbar.
  if (!me) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  // Einmalpasswort noch nicht gewechselt: alle anderen Endpunkte antworten mit
  // 403 password_change_required, also hat jede andere Seite keinen Inhalt.
  if (me.mustChangePassword) {
    return (
      <Routes>
        <Route path="/password" element={<PasswordChangePage />} />
        <Route path="*" element={<Navigate to="/password" replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/password" element={<PasswordChangePage />} />

      <Route element={<Layout />}>
        <Route path="/" element={<DashboardPage />} />

        <Route path="/doorcodes" element={<DoorCodesPage />} />
        <Route path="/doorcodes/:id" element={<DoorCodeDetailPage />} />

        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/groups/:id" element={<GroupDetailPage />} />

        <Route path="/doors" element={<DoorsPage />} />
        <Route path="/doors/:id" element={<DoorDetailPage />} />

        <Route path="/accounts" element={<AccountsPage />} />
        <Route path="/log" element={<LogPage />} />
        <Route path="/audit" element={<AuditPage />} />

        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/organization" element={<OrganizationSettingsPage />} />
        <Route path="/profile" element={<ProfilePage />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
